<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8117 5.9179L10.7083 8.8999C10.3981 9.73816 9.73719 10.3991 8.89892 10.7093L5.91693 11.8127L8.89892 12.9161C9.73718 13.2263 10.3981 13.8872 10.7083 14.7255L11.8117 17.7075L12.9152 14.7255C13.2253 13.8872 13.8863 13.2263 14.7245 12.9161L17.7065 11.8127L14.7245 10.7093C13.8863 10.3991 13.2254 9.73816 12.9152 8.8999L11.8117 5.9179ZM13.0427 4.20174C12.6198 3.05905 11.0036 3.05906 10.5808 4.20174L9.06705 8.29258C8.93411 8.65184 8.65086 8.93509 8.2916 9.06803L4.20076 10.5818C3.05808 11.0046 3.05808 12.6208 4.20076 13.0436L8.2916 14.5574C8.65086 14.6903 8.93411 14.9736 9.06705 15.3328L10.5808 19.4237C11.0036 20.5664 12.6198 20.5664 13.0427 19.4237L14.5564 15.3328C14.6893 14.9736 14.9726 14.6903 15.3318 14.5574L19.4227 13.0436C20.5654 12.6208 20.5654 11.0046 19.4227 10.5818L15.3318 9.06803C14.9726 8.93509 14.6893 8.65184 14.5564 8.29258L13.0427 4.20174Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5607 17.7822L20.1588 18.8683C19.9372 19.4671 19.4651 19.9392 18.8664 20.1607L17.7802 20.5626L18.8664 20.9645C19.4651 21.1861 19.9372 21.6582 20.1588 22.257L20.5607 23.3431L20.9626 22.257C21.1842 21.6582 21.6562 21.1861 22.255 20.9645L23.3412 20.5626L22.255 20.1607C21.6562 19.9392 21.1842 19.4671 20.9626 18.8683L20.5607 17.7822ZM21.3813 16.2178C21.0994 15.456 20.0219 15.456 19.7401 16.2178L18.9278 18.4128C18.8392 18.6523 18.6504 18.8412 18.4109 18.9298L16.2159 19.742C15.4541 20.0239 15.4541 21.1014 16.2159 21.3833L18.4109 22.1955C18.6504 22.2841 18.8392 22.4729 18.9278 22.7124L19.7401 24.9074C20.0219 25.6692 21.0994 25.6692 21.3813 24.9074L22.1935 22.7124C22.2821 22.4729 22.471 22.2841 22.7105 22.1955L24.9055 21.3833C25.6673 21.1014 25.6673 20.0239 24.9055 19.742L22.7105 18.9298C22.471 18.8412 22.2821 18.6523 22.1935 18.4128L21.3813 16.2178Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 28,
    color: "currentColor",
  },
);
</script>
